import { COLOR, FONT_WEIGHT, LazyImage as _LazyImage } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const LIWrapper = styled.li`
  list-style: none;
  background-color: ${COLOR.GRAY100.code};
  margin-bottom: 2px;
`;

export const SpanText = styled.span<{ margin?: string; fontSize?: number }>`
  ${({ margin }) => margin && `margin: ${margin};`}
  ${({ fontSize }) => fontSize && `font-size:${fontSize}px;`}
  font-weight: ${FONT_WEIGHT.BOLD};
`;

export const AnchorListContent = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7.5px 10px;
  min-height: 45px;
`;

export const DivTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DivIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 26px;
  height: 26px;
`;

export const LazyImage = styled(_LazyImage)`
  > picture {
    background: none;
  }
`;

export const SpanMenuNameWithNewTagWrapper = styled.span`
  padding-left: 9.5px;
`;
